interface V2PlaceholderProps {
  page: string;
}

export function V2Placeholder({ page }: V2PlaceholderProps) {
  return <div>{page}</div>;
}
